export default __webpack_public_path__ + "static/media/solvespace_2018-02-21_23-48-32.fe4e9196.png";